import { ApiError, Client, Environment } from 'square';
import request from './request';

// Create an instance of the API Client
// and initialize it with the credentials
// for the Square account whose assets you want to manage
export default new Client({
  // timeout: 3000,
  environment:
    process.env.NEXT_PUBLIC_NODE_ENV === 'production'
      ? Environment.Production
      : Environment.Sandbox,
  accessToken: process.env.NEXT_PUBLIC_SQUARE_ACCESS_TOKEN
});

export async function createPayment(token: string) {
  const body = JSON.stringify({
    locationId: process.env.NEXT_PUBLIC_SQUARE_LOCATION_ID,
    sourceId: token
  });

  try {
    const response = await request('/api/order/1', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
}

export async function tokenize(paymentMethod: any) {
  const tokenResult = await paymentMethod.tokenize();
  if (tokenResult.status === 'OK') {
    return tokenResult.token;
  } else {
    let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
    if (tokenResult.errors) {
      errorMessage += ` and errors: ${JSON.stringify(tokenResult.errors)}`;
    }
    throw new Error(errorMessage);
  }
}

export async function verifyBuyer(
  payments: any,
  token: string,
  {
    addressLine1,
    addressLine2,
    firstName,
    lastName,
    email,
    phone,
    city,
    county,
    country,
    amount
  }: {
    addressLine1: string;
    addressLine2: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    city: string;
    county: string;
    country: string;
    amount: number;
  }
) {
  const verificationDetails = {
    amount: amount.toFixed(2), // formatted to two decimal places
    /* collected from the buyer */
    billingContact: {
      addressLines: [addressLine1, addressLine2].filter((line) => line),
      familyName: lastName,
      givenName: firstName,
      email,
      country,
      phone,
      region: county,
      city
    },
    currencyCode: 'GBP',
    intent: 'CHARGE'
  };

  const verificationResults = await payments.verifyBuyer(token, verificationDetails);
  return verificationResults.token;
}

export const darkModeCardStyle = {
  '.input-container': {
    borderColor: '#727272',
    borderRadius: '0px'
  },
  '.input-container.is-focus': {
    borderColor: '#006AFF'
  },
  '.input-container.is-error': {
    borderColor: '#ff1600'
  },
  '.message-text': {
    color: '#999999'
  },
  '.message-icon': {
    color: '#999999'
  },
  '.message-text.is-error': {
    color: '#ff1600'
  },
  '.message-icon.is-error': {
    color: '#ff1600'
  },
  input: {
    backgroundColor: '#2D2D2D',
    color: '#FFFFFF',
    fontFamily: 'helvetica neue, sans-serif'
  },
  'input::placeholder': {
    color: '#999999'
  },
  'input.is-error': {
    color: '#ff1600'
  },
  '@media screen and (max-width: 600px)': {
    input: {
      fontSize: '12px'
    }
  }
};
